import { BuildRulesetQuery } from '../../../interfaces/Rulesets';
import { extractJsonFieldSql } from '../../extractJsonFieldSql';

export const selectFields_AM_PD: string = `
3 as rank,
id,
label,
attributes
`;

export const order_AM_PD  = 'rank DESC, label';

const getAttributes = (rawName: string) => ({
    cv: `$.148.${rawName}`,
    dpmax: `$.417.${rawName}`,
});

export const buildQuery_AM_PD: BuildRulesetQuery = ({
    selectFields,
    rawName,
    filter,
    volumetricFlow,
    kvs,
}): [string, string[]] => {

    const attrs = getAttributes(rawName);
    return [
        `WITH products_filtered as (SELECT
                       cast(cvAttr.value as float) as cv,
                       cast(dpmaxAttr.value as float) as dpmax,
                       product.id,
                       label,
                       attributes
                    FROM product
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.cv}`)}) as cvAttr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.dpmax}`)}) as dpmaxAttr
                    WHERE ${filter})
            , user_input as (SELECT cast(? as float) as v100, cast(? as float) as cv)
            , bounds as (SELECT
                             cast(floor(cv * 0.89 * 10) as float) / 10 as lower,
                             round(cv * 1.7, 1) as upper,
                             v100,
                             cv
                         FROM user_input)
            SELECT
                ${selectFields}
                       FROM products_filtered
                       JOIN bounds
                       WHERE products_filtered.cv between bounds.lower and bounds.upper
                       AND CASE WHEN bounds.v100 > 0 AND  dpmax > 0
                           THEN pow(bounds.v100 / products_filtered.cv, 2) <= dpmax
                           ELSE true END 
        `,
        [volumetricFlow, kvs]
    ];
}



